const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const NEW_VIEW_TOTAL = 579097;
const DATA_POINT_VIEWS = 525453;

const SCALE_FACTOR = (NEW_VIEW_TOTAL / DATA_POINT_VIEWS);


module.exports.reportData = {
  info: {
    campaignName: 'Sky Westworld',
    influencerName: 'Callux and Calfreezy',
    reportDate: new Date('2018-04-25'),
    campaignHashTag: '#westworld',
    campaignSponsorHandle: '@SkyAtlanticUK',
    campaignArchive: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/campaign-archives/brave-bison-sky-westworld.zip',
    logo: {
      src: '/images/brave-bison-logo.png',
      alt: 'Brave Bison',
      height: 100,
    }
  },
  youtubeViews: NEW_VIEW_TOTAL,
  youtubeEngagements: 38773 * SCALE_FACTOR,
  scaleFactor: SCALE_FACTOR,
  heroData: {
    main: {
      title: 'EMBARRASSING MY BEST FRIEND IN PUBLIC',
      subTitle: `Check out the new season of Westworld exclusively on Sky Atlantic, starting Monday 23rd April.
        Watch the trailer here: https://www.youtube.com/watch?v=9EaW4...
        #Ad`,
      videoUrl: 'https://www.youtube.com/watch?v=sFi3Dqi7sJc',
      views: NEW_VIEW_TOTAL,
      engagements: 38773 * SCALE_FACTOR,
      watchTimeUKIre: 1753248 * SCALE_FACTOR,
      watchTimeTotal: 2506172 * SCALE_FACTOR,
      scaleFactor: SCALE_FACTOR,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [92.5, 7.5],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [11.1, 39.4, 26, 8.3, 5.8, 0.7, 1],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.2, 3.4, 1.3, 0.8, 0.7, 0.1, 0],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 1585786,
        views: 321808,
        likes: 21601,
      },
      {
        name: 'United States',
        watchTime: 167462,
        views: 38224,
        likes: 2790,
      },
      {
        name: 'Australia',
        watchTime: 120721,
        views: 24225,
        likes: 1973,
      },
      {
        name: 'Ireland',
        watchTime: 85467,
        views: 18802,
        likes: 1199,
      },
      {
        name: 'Netherlands',
        watchTime: 47316,
        views: 10776,
        likes: 735,
      },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report2/data/sky-westworld.js